module.exports = __webpack_public_path__ + "static/media/gb16.f1eb4e11.png";